import { useEffect, useRef, useState } from 'react';

const GradeLevelMultiSelect = ({
  options = [],
  value = [],
  onChange,
  placeholder = 'Select grade levels',
  disabled = false,
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = Array.isArray(value) ? value : [];

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, []);

  const toggle = (name) => {
    const next = selected.includes(name)
      ? selected.filter((item) => item !== name)
      : [...selected, name];
    onChange(next);
  };

  return (
    <div ref={rootRef} className={`relative ${className}`}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((current) => !current)}
        className="flex min-h-11 w-full items-center justify-between gap-3 rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-sm focus:outline-none focus:ring-2 focus:ring-brand-medium-blue disabled:cursor-not-allowed disabled:bg-gray-100"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className={selected.length ? 'text-gray-900' : 'text-gray-500'}>
          {selected.length ? selected.join(', ') : placeholder}
        </span>
        <span aria-hidden className="shrink-0 text-gray-500">⌄</span>
      </button>

      {open && (
        <div className="absolute z-[80] mt-1 max-h-60 w-full overflow-y-auto rounded-lg border border-gray-200 bg-white p-2 shadow-xl">
          {options.length === 0 ? (
            <p className="px-2 py-3 text-sm text-gray-500">
              No grade levels configured by admin.
            </p>
          ) : (
            options.map((option) => {
              const name = String(option?.name ?? option).trim();
              return (
                <label
                  key={option?.id ?? name}
                  className="flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 text-sm text-gray-800 hover:bg-gray-50"
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(name)}
                    onChange={() => toggle(name)}
                    className="rounded border-gray-300 text-brand-medium-blue focus:ring-brand-medium-blue"
                  />
                  <span>{name}</span>
                </label>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default GradeLevelMultiSelect;
